export default __webpack_public_path__ + "static/media/AZ.61d5ec63.svg";